// Subscription detail page: frequency pills, qty stepper, live summary, cart submission.
// Pricing display logic: first bag at first_bag_price, each additional at add_bag_price.
// Cart submission: POST /cart/add.js with the selected variant + selling plan + quantity,
// then redirect to the cart. Selling plan IDs come from each frequency pill's data attribute,
// or fall back to the section-level data-selling-plan-id (used when the picker is hidden).

(function () {
  function initSection(root) {
    var firstBag = parseFloat(root.dataset.firstBagPrice);
    var addBag = parseFloat(root.dataset.additionalBagPrice);
    var retailBag = parseFloat(root.dataset.retailBagPrice);
    var minQty = parseInt(root.dataset.minQty, 10) || 1;
    var maxQty = parseInt(root.dataset.maxQty, 10) || 5;
    var unitSingular = root.dataset.unitSingular || 'bag';
    var unitPlural = root.dataset.unitPlural || 'bags';
    var cadenceText = root.dataset.cadenceText || '';
    var variantId = root.dataset.variantId || '';
    var cartUrl = root.dataset.cartUrl || '/cart';

    // Gift (prepaid) config. Only present when the section has gifting enabled
    // and both gift mirror products are wired up; everything below no-ops otherwise.
    // getAttribute (not dataset): data-* names with numeric segments like
    // data-gift-plan-6 do not camelize to dataset.giftPlan6.
    var giftEnabled = root.dataset.giftEnabled === 'true';
    var giftCtaLabel = root.dataset.giftCtaLabel || '';

    var qtyDisplay = root.querySelector('[data-qty-display]');
    var qtyDecBtn = root.querySelector('[data-qty-action="dec"]');
    var qtyIncBtn = root.querySelector('[data-qty-action="inc"]');
    var schedEl = root.querySelector('[data-summary-sched]');
    var retailEl = root.querySelector('[data-summary-retail]');
    var priceEl = root.querySelector('[data-summary-price]');
    var saveEl = root.querySelector('[data-summary-save]');
    var ctaEl = root.querySelector('[data-bic-sub-cta]');
    var errorEl = root.querySelector('[data-bic-sub-error]');

    var giftToggle = root.querySelector('[data-gift-toggle]');
    var giftPanel = root.querySelector('[data-gift-panel]');
    var giftPills = root.querySelectorAll('[data-gift-slot]');
    var giftEmailEl = root.querySelector('[data-gift-recipient-email]');
    var giftMessageEl = root.querySelector('[data-gift-message]');
    var giftMsgCountEl = root.querySelector('[data-gift-msg-count]');
    var giftFromEl = root.querySelector('[data-gift-from]');
    var giftErrorEl = root.querySelector('[data-gift-error]');
    var giftOnceEl = root.querySelector('[data-summary-gift-once]');

    var state = {
      qty: qtyDisplay ? parseInt(qtyDisplay.textContent, 10) || minQty : minQty,
      weeks: 2,
      sellingPlanId: root.dataset.sellingPlanId || '',
      isGift: false,
      giftSlot: '6',
      giftDeliveries: 6,
      giftVariant: '',
      giftLabel: ''
    };

    var pills = root.querySelectorAll('[data-weeks]');
    pills.forEach(function (pill) {
      if (pill.classList.contains('is-selected')) {
        state.weeks = parseInt(pill.dataset.weeks, 10) || state.weeks;
        if (pill.dataset.sellingPlanId) state.sellingPlanId = pill.dataset.sellingPlanId;
      }
      pill.addEventListener('click', function () {
        pills.forEach(function (p) {
          p.classList.remove('is-selected');
          p.setAttribute('aria-checked', 'false');
        });
        pill.classList.add('is-selected');
        pill.setAttribute('aria-checked', 'true');
        state.weeks = parseInt(pill.dataset.weeks, 10);
        if (pill.dataset.sellingPlanId) state.sellingPlanId = pill.dataset.sellingPlanId;
        update();
      });
    });

    root.querySelectorAll('[data-qty-action]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var action = btn.dataset.qtyAction;
        if (action === 'inc' && state.qty < maxQty) state.qty += 1;
        else if (action === 'dec' && state.qty > minQty) state.qty -= 1;
        update();
      });
    });

    // The stepper silently no-ops at its bounds: a shopper stepping down from the
    // default reaches min_qty and the next click on "-" does nothing, with the button
    // still looking live. Disable whichever button cannot move so an unavailable
    // control reads as unavailable rather than broken.
    syncQtyButtons();

    if (giftEnabled && giftToggle) {
      giftToggle.addEventListener('change', function () {
        state.isGift = giftToggle.checked;
        if (giftPanel) giftPanel.hidden = !state.isGift;
        if (ctaEl) {
          if (!ctaEl.dataset.ctaLabel) ctaEl.dataset.ctaLabel = ctaEl.textContent;
          if (giftCtaLabel) {
            ctaEl.textContent = state.isGift ? giftCtaLabel : ctaEl.dataset.ctaLabel;
          }
        }
        clearError();
        clearGiftError();
        update();
      });

      giftPills.forEach(function (pill) {
        if (pill.classList.contains('is-selected')) selectGiftPill(pill);
        pill.addEventListener('click', function () {
          giftPills.forEach(function (p) {
            p.classList.remove('is-selected');
            p.setAttribute('aria-checked', 'false');
          });
          pill.classList.add('is-selected');
          pill.setAttribute('aria-checked', 'true');
          selectGiftPill(pill);
          update();
        });
      });

      if (giftMessageEl && giftMsgCountEl) {
        giftMessageEl.addEventListener('input', function () {
          giftMsgCountEl.textContent = giftMessageEl.value.length + '/300';
        });
      }
    }

    if (ctaEl) {
      ctaEl.addEventListener('click', submit);
    }

    function formatMoney(amount, decimals) {
      return '$' + amount.toFixed(decimals);
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function clearError() {
      if (!errorEl) return;
      errorEl.textContent = '';
      errorEl.hidden = true;
    }

    function showGiftError(message) {
      var el = giftErrorEl || errorEl;
      if (!el) return;
      el.textContent = message;
      el.hidden = false;
    }

    function clearGiftError() {
      if (!giftErrorEl) return;
      giftErrorEl.textContent = '';
      giftErrorEl.hidden = true;
    }

    // The slot key ("6"/"12") is an opaque option name kept for backward
    // compatibility with the live Roaster's Choice settings; the delivery
    // count is the real number of prepaid deliveries (Pinnacle: 3 and 6).
    function selectGiftPill(pill) {
      state.giftSlot = pill.getAttribute('data-gift-slot') || '6';
      state.giftDeliveries = parseInt(pill.getAttribute('data-gift-deliveries'), 10) ||
        parseInt(state.giftSlot, 10) || 6;
      state.giftVariant = pill.getAttribute('data-gift-variant') || '';
      state.giftLabel = (pill.textContent || '').trim();
    }

    // Pill labels are merchant-entered text and the summary uses innerHTML.
    function esc(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    // The gift prepaid selling plan ID lives on the selected frequency pill
    // (data-gift-plan-<slot>, one prepaid plan per cadence per term). Pages
    // without a frequency picker (Pinnacle, monthly only) fall back to the
    // section-level default carried on the root element.
    function currentGiftPlanId() {
      var attr = 'data-gift-plan-' + state.giftSlot;
      var pill = root.querySelector('[data-weeks].is-selected');
      var fromPill = pill ? pill.getAttribute(attr) : '';
      return fromPill || root.getAttribute('data-gift-default-plan-' + state.giftSlot) || '';
    }

    function submitGift() {
      clearGiftError();

      var giftVariantId = state.giftVariant;
      var giftPlanId = currentGiftPlanId();
      if (!giftVariantId || !giftPlanId) {
        showGiftError('The gift option is not fully set up yet. Please contact support.');
        return;
      }

      var email = giftEmailEl ? giftEmailEl.value.trim() : '';
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showGiftError("Please enter your recipient's email address so we can send them their tracking updates.");
        if (giftEmailEl) giftEmailEl.focus();
        return;
      }

      var message = giftMessageEl ? giftMessageEl.value.trim() : '';
      if (message.length > 300) {
        showGiftError('Gift messages can be up to 300 characters.');
        if (giftMessageEl) giftMessageEl.focus();
        return;
      }

      var from = giftFromEl ? giftFromEl.value.trim() : '';

      var label = ctaEl.dataset.ctaLabel || ctaEl.textContent;
      var giftLabel = giftCtaLabel || label;
      ctaEl.classList.add('is-loading');
      ctaEl.textContent = 'Adding…';

      var body = new URLSearchParams();
      body.append('id', giftVariantId);
      body.append('quantity', String(state.qty));
      body.append('selling_plan', giftPlanId);
      body.append('properties[Recipient email]', email);
      if (message) body.append('properties[Gift message]', message);
      if (from) body.append('properties[From]', from);
      body.append('properties[_gift_deliveries]', String(state.giftDeliveries));

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          'Accept': 'application/json'
        },
        body: body.toString()
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            var msg = (result.data && (result.data.description || result.data.message)) ||
              'We could not add this gift to your cart. Please try again.';
            throw new Error(msg);
          }
          window.location.href = cartUrl;
        })
        .catch(function (err) {
          ctaEl.classList.remove('is-loading');
          ctaEl.textContent = giftLabel;
          showGiftError(err.message || 'Something went wrong. Please try again.');
        });
    }

    function submit() {
      clearError();

      if (state.isGift) {
        submitGift();
        return;
      }

      if (!variantId) {
        showError('This subscription is not yet wired up. Please contact support.');
        return;
      }
      if (!state.sellingPlanId) {
        showError('Please choose a delivery frequency.');
        return;
      }

      var label = ctaEl.dataset.ctaLabel || ctaEl.textContent;
      ctaEl.classList.add('is-loading');
      ctaEl.textContent = 'Adding…';

      var body = new URLSearchParams();
      body.append('id', variantId);
      body.append('quantity', String(state.qty));
      body.append('selling_plan', state.sellingPlanId);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          'Accept': 'application/json'
        },
        body: body.toString()
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            var msg = (result.data && (result.data.description || result.data.message)) ||
              'We could not add this subscription to your cart. Please try again.';
            throw new Error(msg);
          }
          window.location.href = cartUrl;
        })
        .catch(function (err) {
          ctaEl.classList.remove('is-loading');
          ctaEl.textContent = label;
          showError(err.message || 'Something went wrong. Please try again.');
        });
    }

    function syncQtyButtons() {
      if (qtyDecBtn) qtyDecBtn.disabled = state.qty <= minQty;
      if (qtyIncBtn) qtyIncBtn.disabled = state.qty >= maxQty;
    }

    function update() {
      if (qtyDisplay) qtyDisplay.textContent = state.qty;
      syncQtyButtons();

      var subPrice = state.qty <= 1 ? firstBag : firstBag + (state.qty - 1) * addBag;
      var retailTotal = state.qty * retailBag;
      var savings = retailTotal - subPrice;

      var unitWord = state.qty === 1 ? unitSingular : unitPlural;
      var weekWord = state.weeks === 1 ? 'week' : 'weeks';
      var cadence = cadenceText
        ? cadenceText
        : 'every ' + state.weeks + ' ' + weekWord;

      if (state.isGift) {
        // Prepaid gift: one charge covering all deliveries. Per-delivery price times
        // the chosen number of installments; retail/savings comparison is hidden.
        var giftTotal = subPrice * state.giftDeliveries;
        if (schedEl) {
          schedEl.innerHTML =
            state.qty + ' ' + unitWord +
            ' <span class="bic-summary__sched-sep" aria-hidden="true">·</span> ' +
            cadence +
            ' <span class="bic-summary__sched-sep" aria-hidden="true">·</span> ' +
            esc(state.giftLabel || state.giftDeliveries + ' deliveries');
        }
        if (retailEl) retailEl.hidden = true;
        if (priceEl) priceEl.textContent = formatMoney(giftTotal, 2);
        if (saveEl) saveEl.hidden = true;
        if (giftOnceEl) giftOnceEl.hidden = false;
        return;
      }

      if (giftOnceEl) giftOnceEl.hidden = true;
      if (retailEl) retailEl.hidden = false;

      if (schedEl) {
        schedEl.innerHTML =
          state.qty + ' ' + unitWord +
          ' <span class="bic-summary__sched-sep" aria-hidden="true">·</span> ' +
          cadence;
      }

      if (retailEl) retailEl.textContent = formatMoney(retailTotal, 0);
      if (priceEl) priceEl.textContent = formatMoney(subPrice, 2);
      if (saveEl) {
        if (savings > 0) {
          saveEl.textContent = 'Save ' + formatMoney(savings, 0);
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }
    }
  }

  function boot() {
    document.querySelectorAll('[data-bic-sub]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
